var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.08,
    cy: 14.08,
    r: 14.08,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4441 7.67999L20.4641 9.6999L18.9242 11.2404L16.9043 9.22051L18.4441 7.67999ZM11.0459 17.0981H13.0658L17.9722 12.1918L15.9523 10.1719L11.0459 15.0782V17.0981Z",
    fill: "#2795AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4525 19.1182H11.1526C11.1351 19.1182 11.1169 19.1249 11.0994 19.1249C11.0772 19.1249 11.055 19.1188 11.0321 19.1182H9.02629V9.69194H13.6364L14.983 8.34534H9.02629C8.28364 8.34534 7.67969 8.94862 7.67969 9.69194V19.1182C7.67969 19.8615 8.28364 20.4648 9.02629 20.4648H18.4525C18.8097 20.4648 19.1522 20.3229 19.4047 20.0704C19.6573 19.8178 19.7991 19.4753 19.7991 19.1182V13.282L18.4525 14.6286V19.1182Z",
    fill: "#2795AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEdit);
export default __webpack_public_path__ + "static/media/image-edit.4bb08e536478414b241cfe55e0415ae0.svg";
export { ForwardRef as ReactComponent };